import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=9286f048&scoped=true&"
var script = {}
import style0 from "./modal.vue?vue&type=style&index=0&id=9286f048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9286f048",
  null
  
)

export default component.exports